const nodeInfoState = {
    LOADING: "loading",
    HIDDEN: "hidden",
    NODEINFO: "nodeinfo",
  };
  
export default nodeInfoState;